// extracted by mini-css-extract-plugin
export default {"r_l":"_55b7d16134 f7684902f8","t":"fc6e640700"};